import React, { useContext, useEffect } from 'react';
/** Mobx state store */
import { observer } from 'mobx-react';
import ListBookings from './components/listBookings';
// import NewBooking from './components/newBooking';
// import ListPendingBookings from './components/listPendingBookings';

// import { getUsers, getVehicles } from './components/service';
import BookingStoreContext from '../../stores/bookingStore';

const Requests = observer(() => {
  const bookingStore = useContext(BookingStoreContext);

  useEffect(() => {
    bookingStore.setValue('isLoading', true);
    return () => {};
  }, [bookingStore]);

  return <ListBookings showOptions={false} requested showStatus={false} />;
});

export default Requests;
